import { defineComponent as _defineComponent } from 'vue'
import { setBlockTracking as _setBlockTracking, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05fb1f1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<span class=\"not-found__status\" data-v-05fb1f1d><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" data-v-05fb1f1d><path fill=\"#FFCC4D\" d=\"M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18\" data-v-05fb1f1d></path><ellipse fill=\"#664500\" cx=\"12\" cy=\"16.5\" rx=\"2.5\" ry=\"2.75\" data-v-05fb1f1d></ellipse><ellipse fill=\"#664500\" cx=\"24\" cy=\"16.5\" rx=\"2.5\" ry=\"3.5\" data-v-05fb1f1d></ellipse><path fill=\"#664500\" d=\"M7.102 12.559c.249.176.574.236.885.135 4.187-1.355 7.027.554 7.146.636.453.312 1.075.201 1.39-.25.315-.451.208-1.071-.241-1.388-.15-.106-3.736-2.575-8.91-.901-.526.17-.814.734-.643 1.259.068.214.203.388.373.509zM25 26H11c-.552 0-1-.447-1-1s.448-1 1-1h14c.553 0 1 .447 1 1s-.447 1-1 1zm5.001-15.592c-.368 0-.731-.161-.979-.471-1.395-1.751-4.299-3.287-5.314-3.287-.642 0-1.925.911-2.604 1.568-.496.482-1.288.467-1.767-.028-.48-.495-.469-1.285.024-1.766.391-.38 2.436-2.275 4.347-2.275 2.005 0 5.538 2.056 7.27 4.229.431.54.341 1.326-.198 1.756-.231.185-.507.274-.779.274z\" data-v-05fb1f1d></path></svg></span><h1 class=\"not-found__heading\" data-v-05fb1f1d>404 Not found</h1>", 2)
const _hoisted_3 = { class: "not-found__desc" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundPage',
  setup(__props) {

const randomQuotes = [
  'How do you even type this url? Are you drunk?',
  'Wait... Who stole the page?',
  'LMAO, OWN3D',
  'Nice url, but lets try to find who asked?',
  'This is not the page you looking for',
  'Life sometimes is a huge dissapointment',
  "There's nothing here, why are you still reading this?",
  'IM GROOT! IM GROOT!',
];

const quote = computed(() => {
  return randomQuotes[Math.floor(Math.random() * randomQuotes.length)] ?? '';
});

return (_ctx: any,_cache: any) => {
  return _cache[0] || (
    _setBlockTracking(-1),
    _cache[0] = _createElementVNode("div", { class: "not-found" }, [
      _hoisted_1,
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(quote)), 1 /* TEXT */)
    ]),
    _setBlockTracking(1),
    _cache[0]
  )
}
}

})